export default __webpack_public_path__ + "static/GuildLogoFinalAlt-e8b77784f790499e6ca0ec16f652b3e1.png";